import React from 'react';
import LeftNav from './../common/leftnav/leftnav';
import HeaderTop from './../common/headerTop/headerTop';
import { SshkeyService } from './../../services/sshkey.service';
import CommonMessage from './../common/commonMessage';
import { ServerService as instanceService } from './../../services/server.service';
import ReactToolTip from 'react-tooltip';
import $ from 'jquery';
import { AuditLog } from './../../services/auditlog.service';
import Region from './../server/region';
import Axios from 'axios';
import { API_HOST } from './../../constants/server.constant';
import RegionService from './../../services/region.service';
import './../server/Region.css';

import { Redirect, Link } from 'react-router-dom';
import { ResourceService } from './../../services/resource.service';
import ScrollArea from 'react-scrollbar';
import { getFullRegionDetail, isKeyValid } from './../../utility/utility';
import NotificationSlider from '../common/topRightHeader/notificationSlider';
import BmrSlider from '../common/topRightHeader/bmrSlider';

class SshKey extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            loading: true,
            sshKeys: [],
            isregionselected: false,
            regionList: [],
            regions: [],
            enablesshkey: false,
            sshkeyname: "",
            sshpubkey: "",
            sshregion: "",
            nametoggle: false,
            datetoggle: false,
            enabledeletesshkey: false,
            deletekeyname: "",
            deletekeyregion: "",
            sshkeyscount: 0,
            message: "",
            msgType: "",
            sshnameempty: false,
            sshkeyempty: false,
            sshregionempty: false,
            addsshkeyerror: false,
            menuoptions: false,
            viewsshkey: false,
            enableviewsshkey: false,
            getsshname: "",
            getsshdate: "",
            sshkeyuser: localStorage.getItem("email"),
            isAction: false,
            isNameActive: false,
            isRegionActive: true,
            nametoggle: false,
            regiontoggle: true,
            sshnameexists: false,
            regionListFilter: [],
            regionid: "",
            countryName: "",
            isUserSubscribed: false,
            isRedirectCCPage: false,
            sshKeyRegex: false,
            deleteSecretref: "",
            isAddKeyDisable: false,
            viewpubkey: "",
            count: 50,
            indexCount: 0,
            sshKeysPaged: []
        };
        this.sshregionfocus = React.createRef();
        this.sshkeynamefocus = React.createRef();
        this.sshpubkeyfocus = React.createRef();
        this.checkForSubscription = this.checkForSubscription.bind(this);
        this.enableSshKey = this.enableSshKey.bind(this);
        this.handleInput = this.handleInput.bind(this);
        this.addKey = this.addKey.bind(this);
        this.deleteKey = this.deleteKey.bind(this);
        this.setSortable = this.setSortable.bind(this);
        this.enableDeleteSshKey = this.enableDeleteSshKey.bind(this);
        this.getSshKeyDetails = this.getSshKeyDetails.bind(this);
        this.enableMenuOptions = this.enableMenuOptions.bind(this);
        this.escfunction = this.escfunction.bind(this);
        this.getAllSshKeys = this.getAllSshKeys.bind(this);
        this.close = this.close.bind(this);
        this.getRegionDropdown = this.getRegionDropdown.bind(this);
        this.filterDropDown = this.filterDropDown.bind(this);
        this.getSelectedRegion = this.getSelectedRegion.bind(this);
        this.enterPressed = this.enterPressed.bind(this);


    };
    enterPressed(event, param) {
        var code = event.keyCode || event.which;
        if(code === 13 && param === "add") {
            this.addKey();
        }

    }
    close = (event, param) => {
        event.preventDefault();

        if(param === "addsshkey") {
            $(".add_ssh_key").removeClass("active");
            $("body").removeClass("popup_no_scroll");

        }
        else if(param === "viewssh") {
            $(".sshKey_viewDetail_slider").removeClass("active");
        }
        else if(param === "delete") {
            $(".delete_user_popup").removeClass("active");
            $("body").removeClass("popup_no_scroll");
        }

    };
    escfunction(event) {
        if(event.keyCode === 27) {
            this.setState({
                enabledeletesshkey: false,
                enableviewsshkey: false,
                enablesshkey: false,
                sshkeyname: "",
                sshpubkey: "",
                isAddKeyDisable: false
            });
            $(".add_ssh_key").removeClass("active");
            $(".sshKey_viewDetail_slider").removeClass("active");
            $(".delete_user_popup").removeClass("active");
            $("body").removeClass("popup_no_scroll");

        }
    }

    componentWillUnmount() {
        document.removeEventListener("keyup", this.escfunction, false);
    }

    componentDidMount() {
        console.log(this.props);
        document.addEventListener("keyup", this.escfunction, false);
        //this.loadcss();
        this.setState({
            isAction: true
        });
        this.checkForSubscription();
    }

    checkForSubscription = () => {
        ResourceService.getSubscriptionDetails().then(resp => {
            if(resp === false) {
                this.setState({
                    isAction: false,
                    message: "Error while getting user subscription details"

                });
                return;
            }
            if(resp.error) {
                this.setState({
                    isAction: false,
                    isUserSubscribed: true
                });
                this.loadRegions();
            }
            else {
                this.getAllSshKeys();

            }

        });
    };



    loadRegions = () => {
        RegionService.getAll().then((resp) => {
            if(resp === false) {
                this.setState({
                    regionListFilter: []
                });
            }
            this.setState({
                regionList: resp
            });
        });

    };

    getAllSshKeys = () => {
        SshkeyService.getSshKeyList("noncreate").then(res => {
            if(res === false) {
                this.setState({
                    message: "Error while listing keys, try again!",
                    isAction: false
                });
                return;
            }
            if(res === "INVALID_CREATOR") {
                this.setState({
                    message: "Access Denied",
                    isAction: false
                });
                return;
            }
            if(res.length > 0) {
                let sshsort = res;
                let sshKeysPaged = [...sshsort];
                sshsort.sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                });
                if(sshsort.length > this.state.count) sshKeysPaged = sshKeysPaged.slice(0, this.state.count);
                this.setState({
                    sshKeys: sshsort,
                    sshkeyscount: sshsort.length,
                    isAction: false,
                    sshKeysPaged: sshKeysPaged,
                    indexCount: 0
                }, () => this.activateActionMenu());
                this.loadRegions();
            }
            else {
                this.setState({
                    sshKeys: res,
                    sshkeyscount: res.length,
                    isAction: false

                }, () => this.activateActionMenu());
            }



        });
    };
    activateActionMenu() {
        var documentwindowHeight = $(document).height();
        $('.dashboard_module .table_data .tr .row_menu_icon, .tabular_data_wrap li .menu_icon').click(function () {
            $('.tabular_data_wrap .table_data .tr').removeClass('active');
            $(this).closest('.tr').addClass('active');
            //$(this).closest('.dashboard_module .tr').find('.dropdown_component').toggleClass('active');
            $(this).find('.dropdown_component').css({ top: '30px' });
            var fmi = 'dropdown_component';
            var offset = $(this).offset();
            var x = (offset.left);
            var y = (offset.top);
            var windowHeight = $(window).height();
            var menuHeight = $(this).find('.' + fmi).height();
            var totalHeight = menuHeight + y;
            if(documentwindowHeight < totalHeight) {
                $('.' + fmi).css({ top: -Math.abs(menuHeight + 10) });
                $('.arrow_pointer').addClass('bottom_arrow');
            }
            else if(documentwindowHeight > totalHeight) {
                totalHeight = totalHeight - windowHeight;
                totalHeight = totalHeight + 50;
                $('.arrow_pointer').removeClass('bottom_arrow');

                window.scrollTo({ top: totalHeight, behavior: 'smooth', });
            }
        });
    }


    loadcss = () => {
        const link = document.createElement("link");
        link.href = "https://www.idrivecompute.com/webapp/css/ssh-key.css";
        link.rel = "stylesheet";
        link.type = "text/css";
        document.head.appendChild(link);
    };

    enableSshKey = () => {
        $(".add_ssh_key").addClass("active");
        $(".regionSelect_options").removeClass('active');
        $("body").addClass("popup_no_scroll");

        this.setState({
            sshregionempty: false,
            sshkeyempty: false,
            sshnameempty: false,
            sshKeyRegex: false,
            sshregion: "",
            sshkeyname: "",
            sshpubkey: "",
            addsshkeyerror: false,
            sshnameexists: false,
            regionListFilter: [],
            countryName: "",
            regionid: "",
            isAddKeyDisable: false,
        });
        setTimeout(() => {
            this.sshkeynamefocus.current.focus();
        }, 100);

    };

    enableMenuOptions = (event, name, date) => {
        $(event.currentTarget).closest('.tr').find('.sshKey_row_options').toggleClass('active');
        this.setState({
            getsshname: name,
            getsshdate: date
        });
    };


    handleInput = (event) => {
        let name = event.target.name;
        let val = event.target.value;
        this.setState({
            [name]: val
        });
        if(name === "sshkeyname") {
            this.setState({
                sshnameexists: false
            });

            if(val.length > 0) {
                this.setState({
                    sshnameempty: false
                });
                var sshRegex = new RegExp("^[a-zA-Z0-9-_ ]*$");
                if(sshRegex.test(val)) {
                    this.setState({
                        sshKeyRegex: false
                    });
                }
                else {
                    this.setState({
                        sshKeyRegex: true
                    });
                }

            }
            else {
                this.setState({
                    sshnameempty: true,
                    sshKeyRegex: false,

                });

            }
        }
        else if(name === "sshpubkey") {
            this.setState({
                addsshkeyerror: false
            });
            if(val.length > 0) {
                this.setState({
                    sshkeyempty: false
                });

            }
            else {
                this.setState({
                    sshkeyempty: true
                });

            }
        } else if(name === "sshregion") {
            if(val.length > 0) {
                this.setState({
                    sshregionempty: false
                });

            }
            else {
                this.setState({
                    sshregionempty: true
                });

            }
        }

    };

    setSortable = (param) => {

        let items = [...this.state.sshKeys];
        if(param[0] === "name") {
            if(this.state.nametoggle) {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return 1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return -1; }
                    return 0;
                });

            }
            else {
                items.sort(function (a, b) {
                    if(a.name.toLowerCase() < b.name.toLowerCase()) { return -1; }
                    if(a.name.toLowerCase() > b.name.toLowerCase()) { return 1; }
                    return 0;
                });

            }
            this.setState({
                //sshKeysPaged: items,
                nametoggle: !this.state.nametoggle,
                isNameActive: true,
                isRegionActive: false
            });

        }
        else if(param[0] === "region") {
            if(this.state.regiontoggle) {
                items.sort(function (a, b) {
                    return new Date(a.date) - new Date(b.date);
                });
            } else {
                items.sort(function (a, b) {
                    return new Date(b.date) - new Date(a.date);
                });

            }
            this.setState({
                //sshKeysPaged: items,
                regiontoggle: !this.state.regiontoggle,
                isNameActive: false,
                isRegionActive: true
            });


        }
        let sshKeysPaged = [...items];
        if(sshKeysPaged.length > this.state.count) sshKeysPaged = sshKeysPaged.slice(0, this.state.count);
        this.setState({
            sshKeys: items,
            sshKeysPaged: sshKeysPaged,
            indexCount: 0
        });



    };


    addKey = () => {
        this.setState({
            sshregionempty: false,
            sshnameempty: false,
            sshkeyempty: false,
            sshKeyRegex: false
        });

        if(this.state.sshkeyname.length <= 0) {
            this.setState({
                sshnameempty: true
            });

            this.sshkeynamefocus.current.focus();
        }
        else if(this.state.sshpubkey.length <= 0) {
            this.setState({
                sshkeyempty: true
            });
            this.sshpubkeyfocus.current.focus();
        }
        else if(this.state.sshKeyRegex) {
            this.setState({
                sshKeyRegex: true
            });

            this.sshkeynamefocus.current.focus();
        }
        else {
            if(this.state.isUserSubscribed) {
                this.setState({
                    isRedirectCCPage: true
                });
            } else if(!isKeyValid(this.state.sshpubkey.trim())) {
                this.setState({
                    addsshkeyerror: true
                });
                this.sshpubkeyfocus.current.focus();
                return;
            } else {
                this.setState({

                    sshnameempty: false,
                    sshkeyempty: false,
                    sshKeyRegex: false,
                    isAction: true,
                    isAddKeyDisable: true
                });
                const data = {
                    name: this.state.sshkeyname.trim(),
                    public_key: this.state.sshpubkey.trim(),
                };

                SshkeyService.addSshKey(data.name, data.public_key).then(res => {
                    if(res === false) {
                        this.setState({
                            message: "Failed to add key",
                            msgType: "error",
                            isAddKeyDisable: false,
                            isAction: false
                        });
                        return;
                    }
                    if(res.data.body !== null) {
                        if(res.data.body.hasOwnProperty("secret_ref")) {
                            SshkeyService.getSshKeyList("noncreate").then(res => {
                                res.sort(function (a, b) {
                                    return new Date(b.date) - new Date(a.date);
                                });
                                let sshKeysPaged = [...res];
                                this.setState({
                                    sshKeys: res,
                                    sshKeysPaged: sshKeysPaged.slice(0, this.state.count),
                                    sshkeyscount: res.length,
                                    message: "SSH key added successfully",
                                    msgType: "success",
                                    isAddKeyDisable: false,
                                    isAction: false,
                                    indexCount: 0
                                }, () => this.activateActionMenu());
                            });
                            let fullRegionList = JSON.parse(localStorage.getItem('fullRegionList'));
                            const addsshkey = {
                                "userId": localStorage.getItem("userId"),
                                "name": "SSH key " + data.name + " has been added",
                                "operation": "SSH key added",
                                "region": ""
                            };
                            AuditLog.storeAuditLogs(addsshkey, "instance").then((resp) => {
                                if(resp === false);
                            });
                            $(".add_ssh_key").removeClass("active");
                            $("body").removeClass("popup_no_scroll");

                        }
                        else if(res.data.body.hasOwnProperty("conflictingRequest")) {
                            this.setState({
                                sshnameexists: true,
                                isAddKeyDisable: false,
                                isAction: false
                            });
                            this.sshkeynamefocus.current.focus();
                            return;
                        }
                        else {

                            this.setState({
                                addsshkeyerror: true,
                                isAddKeyDisable: false,
                                isAction: false
                            });
                            this.sshpubkeyfocus.current.focus();
                        }

                    }
                    else {
                        this.setState({
                            addsshkeyerror: true,
                            isAddKeyDisable: false,
                            isAction: false
                        });
                    }

                });


            }

        }

    };

    deleteKey = () => {

        this.setState({
            isAction: true
        });
        $(".delete_user_popup").removeClass("active");
        $("body").removeClass("popup_no_scroll");

        const keyname = {
            name: this.state.deleteSecretref
        };

        let keynameSsh = this.state.deletekeyname;

        SshkeyService.deleteSshKey(keyname).then(res => {
            if(res === false) {
                this.setState({
                    message: "Error while deleting SSH key",
                    msgType: "error",
                    isAction: false
                });
            }
            else if(res.data.body === null) {
                this.setState({
                    message: "The SSH key \"" + keynameSsh + "\" Deleted Successfully",
                    msgType: "success"
                });

                const removesshkey = {
                    "userId": localStorage.getItem("userId"),
                    "name": "SSH key \"" + keynameSsh + "\" has been deleted",
                    "operation": "SSH key deleted",
                    "region": ""
                };
                AuditLog.storeAuditLogs(removesshkey, "instance").then((resp) => {
                    if(resp === false);
                });
                $(".delete_user_popup").removeClass("active");
                $("body").removeClass("popup_no_scroll");
                this.getAllSshKeys();
            }
            else if(res.data.body != null) {
                if(!(res.data.body.hasOwnProperty("description"))) {
                    this.getAllSshKeys();
                }
                else {
                    this.setState({
                        message: res.data.body.description,
                        msgType: "error",
                        isAction: false
                    });
                }

            }



        });
    };

    copyToclipboard = (event, text) => {
        this.setState({
            isCopied: true
        });
        var container = event.currentTarget;
        let tempInnerHtml = container.innerHTML;
        container.innerHTML = text;
        window.getSelection().removeAllRanges();
        let range = document.createRange();
        range.selectNode(container);
        window.getSelection().addRange(range);
        document.execCommand('copy');
        window.getSelection().removeAllRanges();
        container.innerHTML = tempInnerHtml;
    };

    getSshKeyDetails = (uuid) => {
        var scr_top = document.getElementById("viewpubkey");
        scr_top.scrollLeft = 0;
        scr_top.scrollTop = 0;
        $(".sshKey_viewDetail_slider").toggleClass("active");
        this.setState({
            isAction: true
        });
        SshkeyService.getSshKeyDetails(uuid).then(resp => {
            console.log(resp);
            this.setState({
                viewsshname: this.state.getsshname,
                viewcreateddate: this.state.getsshdate,
                viewsshuser: this.state.sshkeyuser,
                viewpubkey: resp.data,
                isAction: false
            });
        })
            .catch(error => {
                this.setState({
                    message: "Error while fetching ssh keys details",
                    isAction: false
                });
            });



    };

    enableDeleteSshKey = (url, name) => {
        this.setState({
            deleteSecretref: url,
            deletekeyname: name
        });
        $(".delete_user_popup").addClass("active");
        $("body").addClass("popup_no_scroll");

        document.getElementById("deleteSshKey").focus();
    };

    getRegionDropdown = () => {
        $(".regionSelect_options").addClass("active");

        this.setState({
            regionListFilter: this.state.regionList,
            sshregion: "",
            isregionselected: false
        });
    };
    filterDropDown = (event) => {
        $(".regionSelect_options").addClass("active");

        let name = event.target.name;
        let val = event.target.value;

        this.setState({
            regionListFilter: this.state.regionList.filter(item => item.name.toLowerCase().includes(val.toLowerCase())),
            sshregion: val
        });

    };

    getSelectedRegion = (event, regionOb) => {
        if(regionOb.status !== 1) {
            return;
        }
        $(".regionSelect_options").removeClass("active");
        this.setState({
            sshregion: regionOb.name,
            regionid: regionOb.id,
            isregionselected: true,
            countryName: regionOb.countryName
        });

    };
    handleNextClick = (event) => {
        let sshKeys = this.state.sshKeys;
        let indexCount = this.state.indexCount + this.state.count;
        let endCount = indexCount + this.state.count;
        if(endCount > sshKeys.length) endCount = sshKeys.length;
        this.setState({
            indexCount: indexCount,
            sshKeysPaged: sshKeys.slice(indexCount, endCount)
        });
        event.preventDefault();
    };

    handlePreviousClick = (event) => {
        let sshKeys = this.state.sshKeys;
        let indexCount = this.state.indexCount - this.state.count;
        this.setState({
            indexCount: this.state.indexCount - this.state.count,
            sshKeysPaged: sshKeys.slice(indexCount, this.state.indexCount)
        });
        event.preventDefault();
    };

    render() {
        if(this.state.isRedirectCCPage) {
            return <Redirect to={ {
                pathname: "/billing/creditcard",
                state: { message: true }
            } }></Redirect>;
        }

        sessionStorage.sshkeyLoaded = true;
        return (
            <div className="main_nav_module sshKey_main_module">
                <main>
                    <div className="full_page_loader" style={ { display: this.state.isAction ? 'block' : 'none' } }>
                        <div className="loader_icon"></div>
                    </div>
                    <LeftNav isActive={ 'sshkey' }></LeftNav>

                    <div className="main_container">
                        <header className="header_wrap">
                            <HeaderTop showCreate={ true } isUserSubscribed={ this.state.isUserSubscribed }></HeaderTop>
                            <div className="header_wrap_bottom">
                                <div className="bottom_navbar">
                                    <div className="bn_left">
                                        <div className="computer_no">
                                            <span className="text bold_600">SSH Keys</span>
                                        </div>
                                    </div>
                                    { this.state.sshkeyscount === 0 ? "" :
                                        <div className="bn_right">
                                            <div className="rhs_info">
                                                <p>Number of SSH keys : { this.state.sshkeyscount }</p>
                                            </div>
                                            <div className="divider"></div>

                                            <div className="rhs_cta">
                                                <div className="btn_wrap_icon btnDefaultPad" onClick={ this.enableSshKey }>
                                                    <input
                                                        type="button"
                                                        name=""
                                                        value="Add SSH Key"
                                                        className="common_cta_btn blue add_ssh_cta" />
                                                </div>
                                            </div>
                                        </div>
                                    }
                                </div>
                            </div>
                        </header>
                        <NotificationSlider />
                        <section className="main_section pagination__wrap">
                            <div className="main_body_container">
                                <div className="mainBody_colWrap">
                                    <div className="ssh_key_container">
                                        <div className="ssh_key_table">
                                            <div className="tabular_data_wrap global_sshTable">
                                                <div className="table_header">
                                                    <ul>
                                                        <li className="th">
                                                            <div className="col col1">
                                                                <div className="header_sort_wrap" onClick={ () => this.setSortable(["name"]) }>Name<span className={ this.state.isNameActive ? this.state.nametoggle ? "sort_icon active toggle_sort" : "sort_icon active" : "sort_icon" } ></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col2">
                                                                <div className="header_sort_wrap" onClick={ () => this.setSortable(["region"]) }>Created On<span className={ this.state.isRegionActive ? this.state.regiontoggle ? "sort_icon active toggle_sort" : "sort_icon active" : "sort_icon" } ></span>
                                                                </div>
                                                            </div>
                                                            <div className="col col4">
                                                                <div className="header_sort_wrap">Actions
                                                                </div>
                                                            </div>
                                                        </li>
                                                    </ul>
                                                </div>
                                                <div className="table_data">
                                                    { this.state.sshkeyscount === 0 && !this.state.isAction ?
                                                        <ul>
                                                            <li>
                                                                <div className="outer_empty_wrap fullPageEmpty">
                                                                    <div className="inner_empty_wrap">
                                                                        <div className="svg_wrap empty_icon sshKeyCreate_empty"></div>
                                                                        <p className="empty_head">SSH Keys</p>
                                                                        <p className="empty_title">Add SSH keys to your account and use those while creating instances for logging in securely.</p>
                                                                        <div className="btn_wrap_icon btnDefaultPad"><input type="button" value="Add SSH Key" className="common_cta_btn blue" onClick={ this.enableSshKey }></input></div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        </ul>
                                                        :
                                                        <ul>
                                                            { this
                                                                .state
                                                                .sshKeysPaged
                                                                .map((sshKey, i) => <li className="tr" key={ i }>
                                                                    <div className="col col1" >
                                                                        <div className="name_icon">
                                                                            <span className="svg_wrap">
                                                                                <svg x="0px" y="0px" viewBox="0 0 18.1 19.7" style={ { enableBackground: 'new 0 0 18.1 19.7' } } xmlSpace="preserve">
                                                                                    <path className="st0" d="M15.1,11.8c-1.8,1.8-4.4,2.1-6.5,0.9l-1.3,1.3l1.1,1.1c0.6,0.6,0.6,1.5,0,2.1L7.7,18c-0.6,0.6-1.5,0.6-2.1,0
                                                                                l-1-1.1l-0.3,0.4c-0.6,0.6-1.5,0.6-2.1,0c-0.6-0.6-0.6-1.5,0-2.1l4.3-4.4C5.2,8.6,5.5,5.8,7.3,4c2.1-2.1,5.6-2.1,7.8,0
                                                                                C17.3,6.2,17.3,9.7,15.1,11.8z M13,6.2c-1-1-2.5-1-3.5,0c-1,1-1,2.6,0,3.5c1,1,2.5,1,3.5,0C13.9,8.7,13.9,7.1,13,6.2z"></path>
                                                                                </svg>
                                                                            </span>
                                                                        </div>
                                                                        <span className="sshName" ><span>{ sshKey.name }</span></span>

                                                                    </div>
                                                                    <div className="col col2" >
                                                                        <div className="name_icon">
                                                                            <span className="txt">{ sshKey.date }</span>
                                                                        </div>
                                                                    </div>

                                                                    <div className="col col4"><span className="menu_icon" onClick={ (e) => this.enableMenuOptions(e, sshKey.name, sshKey.date) }><span className="svg_wrap"><svg className="horizMenuIcon" data-tip data-for="actions" x="0px" y="0px" viewBox="0 0 22.1 6.3" enableBackground="new 0 0 22.1 6.3" xmlSpace="preserve">
                                                                        <path fillRule="evenodd" clipRule="evenodd" fill="#8692B0" d="M19,5.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5s2.5,1.1,2.5,2.5  S20.4,5.7,19,5.7z M11,5.7c-1.4,0-2.5-1.1-2.5-2.5S9.6,0.7,11,0.7s2.5,1.1,2.5,2.5S12.4,5.7,11,5.7z M3,5.7c-1.4,0-2.5-1.1-2.5-2.5  S1.6,0.7,3,0.7s2.5,1.1,2.5,2.5S4.4,5.7,3,5.7z"></path>
                                                                    </svg><ReactToolTip id="actions" place="top" effect="solid">Actions</ReactToolTip></span>
                                                                        <ul className="dropdown_component sshKey_row_options">
                                                                            <span className="arrow_pointer"></span>
                                                                            <li className="view_details" onClick={ () => this.getSshKeyDetails(sshKey.secretref) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 23 23" enableBackground="new 0 0 23 23" xmlSpace="preserve">

                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#606060" d="M11.5,18.5c-8,0-10-7-10-7s2.1-7,10-7c8.7,0,10,7,10,7  S19.3,18.5,11.5,18.5z M11.5,6.5c-6.6,0-8,5-8,5s1.2,5,8,5s8-5,8-5S18.1,6.5,11.5,6.5z M11.5,15.5c-2.2,0-4-1.8-4-4s1.8-4,4-4  s4,1.8,4,4S13.7,15.5,11.5,15.5z M11.5,9.5c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S12.6,9.5,11.5,9.5z" />

                                                                                <g display="none">

                                                                                    <path display="inline" fill="#606060" d="M17.8,6.2l-1.5,1.5c2.5,1.5,3.2,3.8,3.2,3.8s-1.2,5-8,5C10.1,16.5,9,16.3,8,16l-1.5,1.5   c1.3,0.6,2.9,1.1,4.9,1.1c7.8,0,10-7,10-7S20.9,8.3,17.8,6.2z" />

                                                                                    <path display="inline" fill="#606060" d="M5.3,16.7l1.3-1.3c-2.6-1.5-3.1-3.8-3.1-3.8s1.4-5,8-5c1.4,0,2.5,0.2,3.4,0.6l1.6-1.6   c-1.3-0.6-2.9-1-5-1c-7.9,0-10,7-10,7S2.4,14.6,5.3,16.7z" />

                                                                                    <path display="inline" fill="#606060" d="M13.5,11.5c0,1.1-0.9,2-2,2c-0.3,0-0.6-0.1-0.8-0.2l-1.5,1.5c0.6,0.4,1.4,0.7,2.3,0.7   c2.2,0,4-1.8,4-4c0-0.8-0.3-1.6-0.7-2.3l-1.5,1.5C13.4,10.9,13.5,11.2,13.5,11.5z" />

                                                                                    <path display="inline" fill="#606060" d="M7.5,11.5c0,0.8,0.3,1.6,0.7,2.3l1.5-1.5c-0.1-0.2-0.2-0.5-0.2-0.8c0-1.1,0.9-2,2-2   c0.3,0,0.6,0.1,0.8,0.2l1.5-1.5c-0.6-0.4-1.4-0.7-2.3-0.7C9.3,7.5,7.5,9.3,7.5,11.5z" />



                                                                                    <rect x="11.8" y="2.2" transform="matrix(0.7071 0.7071 -0.7071 0.7071 12.5 -5.1777)" display="inline" fillRule="evenodd" clipRule="evenodd" fill="#606060" width="1.4" height="20.7" />

                                                                                </g>

                                                                            </svg></span></span>View Details</li>
                                                                            <li className="delete" onClick={ () => this.enableDeleteSshKey(sshKey.secretref, sshKey.name) }><span className="icon"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 512 512" enableBackground="new 0 0 512 512" xmlSpace="preserve">
                                                                                <path fillRule="evenodd" clipRule="evenodd" fill="#4C8CCD" d="M433.5,116.8v303.5c0,27.9-22.7,50.6-50.6,50.6H129.9  c-28,0-50.6-22.7-50.6-50.6V116.8H54.1V66.2h75.9h25.3V40.9h202.4v25.3h25.3h75.9v50.6H433.5z M382.9,116.8H129.9v303.5h252.9V116.8  z M231.1,369.7h-50.6V167.4h50.6V369.7z M332.3,369.7h-50.6V167.4h50.6V369.7z"></path>
                                                                            </svg></span></span>Delete</li>
                                                                        </ul>
                                                                    </span></div>
                                                                </li>
                                                                ) }

                                                        </ul>
                                                    }
                                                </div>
                                                <div className="pagination_inner__box remove-bg" style={ { display: this.state.sshKeys.length > this.state.count ? '' : 'none' } }>
                                                    <div className="Page_navigation">
                                                        <ul className="pagination_ul">
                                                            <li className={ this.state.indexCount === 0 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Previous" data-tip data-for="prev-page" onClick={ (event) => { this.handlePreviousClick(event); } }>
                                                                    <ReactToolTip id="prev-page" place="top" effect="solid">Previous</ReactToolTip>
                                                                    <span aria-hidden="true">«</span>
                                                                    <span className="sr-only">Previous</span>
                                                                </a>
                                                            </li>
                                                            <li className="page-item">
                                                                <a className="page-link" data-toggle="tooltip" data-placement="top" title="" data-original-title="0-50">
                                                                    { this.state.indexCount + 1 } - { (this.state.indexCount + this.state.count) > this.state.sshKeys.length ? this.state.sshKeys.length : (this.state.indexCount + this.state.count) }
                                                                </a>
                                                            </li>
                                                            <li className={ this.state.indexCount + this.state.count > this.state.sshKeys.length - 1 ? "page-item disabled" : "page-item" }>
                                                                <a className="page-link hover-btn" aria-label="Next" data-tip data-for="next-page" onClick={ (event) => { this.handleNextClick(event); } }>
                                                                    <ReactToolTip id="next-page" place="top" effect="solid">Next</ReactToolTip>
                                                                    <span aria-hidden="true">»</span>
                                                                    <span className="sr-only">Next</span>
                                                                </a>
                                                            </li>
                                                        </ul>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                        <div className="main_slider add_ssh_key">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" onClick={ (e) => this.close(e, "addsshkey") }></div>
                                    <div className="sshKey_slide_wrap">
                                        <div className="head_block">
                                            <h2>
                                                <span className="icon_img" >
                                                    <span className="icon"></span>
                                                </span>Add SSH Key</h2>
                                        </div>
                                        <div className="sshKey_content_wrap">
                                            <p className="info_txt" ><a href="https://www.idrivecompute.com/faq_instances.htm#generate-sshkey" target="_blank">See instructions to <b>generate a new SSH key</b></a></p>
                                            <div className="common_txtBox_row region_select" style={ { display: "none" } }>
                                                <label>Regions</label>
                                                <div className="region_select_container">
                                                    <div className="slectBox" onClick={ this.getRegionDropdown }>
                                                        <div className={ this.state.isregionselected ? "search_inp_box optSelect" : "search_inp_box optUnselect" } >
                                                            <input type="text" autoComplete="off" placeholder="Select a Region" ref={ this.sshregionfocus } name="sshregion" value={ this.state.sshregion } onChange={ this.filterDropDown }></input>
                                                            <input type="hidden" name="regionid" value={ this.state.regionid }></input>
                                                        </div>
                                                        <ul>
                                                            <li className="selected_elem">
                                                                <span className={ this.state.sshregion.length > 0 ? "country_flag " + this.state.countryName.toLowerCase() : "" }></span>{ this.state.sshregion.length <= 0 ? this.state.sshregion : this.state.sshregion + " (" + this.state.regionid + ")" }
                                                            </li>
                                                        </ul>

                                                        <span className="dropArrow" > <svg className="header_nav_dropdown" viewBox="0 0 10 5">
                                                            <title>drop-down</title>
                                                            <polygon className="cls-1" points="5 5 0 0 10 0 5 5"></polygon>
                                                        </svg>
                                                        </span>
                                                    </div>
                                                    <div className="regionSelect_options">

                                                        { this.state.regionListFilter.length <= 0 ?
                                                            <ul className="noSearchRes" style={ { display: this.state.regionListFilter.length <= 0 ? "" : "none" } }>
                                                                <li>No Search Found</li>
                                                            </ul>
                                                            :
                                                            <ul>
                                                                <ScrollArea
                                                                    speed={ 0.8 }
                                                                    style={ { maxHeight: "245px" } }
                                                                    vertical={ true }
                                                                    horizontal={ false }
                                                                    minScrollSize={ 10 }
                                                                    smoothScrolling={ false }
                                                                    verticalScrollbarStyle={ { backgroundColor: "#C1C1C1", opacity: "1" } }
                                                                    verticalContainerStyle={ { backgroundColor: "#F1F1F1", opacity: "1" } }
                                                                    stopScrollPropagation={ true }
                                                                >
                                                                    { this.state.regionListFilter.map((region, i) =>
                                                                        <li className={ "option_elem " + region.statusClass } key={ i } onMouseDown={ (e) => this.getSelectedRegion(e, region) } disabled={ region.status !== 1 }><span className={ 'country_flag ' + region.countryName.toLowerCase() } ></span>{ region.name } ({ region.id })<span className="algin_right__arrow" style={ { display: region.status === 1 ? 'none' : '' } }>{ region.statusName }</span>
                                                                        </li>
                                                                    ) }
                                                                </ScrollArea>

                                                            </ul>
                                                        }

                                                    </div>
                                                </div>
                                                <span className="err_msg" style={ { display: this.state.sshregionempty ? 'inline-block' : 'none', color: "red" } } >Region cannot be blank</span>
                                            </div>

                                            <div className="common_txtBox_row">
                                                <label>Key Name</label>
                                                <input type="text" ref={ this.sshkeynamefocus } maxLength="20"
                                                    value={ this.state.sshkeyname }
                                                    autoComplete="off"
                                                    placeholder="Provide a key name"
                                                    onClick={ (e) => this.enterPressed(e, "add") }
                                                    name="sshkeyname" className="txt_box" onChange={ this.handleInput } />
                                                <span className="err_msg" style={ { display: this.state.sshnameempty ? 'inline-block' : 'none', color: "red" } } >Key name cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.sshKeyRegex ? 'inline-block' : 'none', color: "red" } } >Key name can contains a-z, A-Z, 0-9, -, _ characters</span>
                                                <span className="err_msg" style={ { display: this.state.sshnameexists ? 'inline-block' : 'none', color: "red" } } >Key name already exists</span>

                                            </div>
                                            <div className="common_txtBox_row">
                                                <label>SSH Public Key</label>
                                                <textarea ref={ this.sshpubkeyfocus } onClick={ (e) => this.enterPressed(e, "add") } placeholder='Provide your SSH public key' name="sshpubkey" value={ this.state.sshpubkey } onChange={ this.handleInput }></textarea>
                                                <span className="err_msg" style={ { display: this.state.sshkeyempty ? 'inline-block' : 'none', color: "red" } } >Keypair cannot be blank</span>
                                                <span className="err_msg" style={ { display: this.state.addsshkeyerror ? 'inline-block' : 'none', color: "red" } } >SSH key is invalid</span>
                                            </div>

                                            <div className="cta_wrap">
                                                <input type="button" id="addKeyFocus" name="" value="Add Key" className={ this.state.isAddKeyDisable ? "common_cta_btn blue disabled" : "common_cta_btn blue" } disabled={ this.state.isAddKeyDisable } onClick={ this.addKey } />
                                                <input
                                                    type="button"
                                                    name=""
                                                    value="Cancel"
                                                    className="common_cta_btn transparentGrey"
                                                    onClick={ (e) => this.close(e, "addsshkey") }
                                                />
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/*Delete Sshkey*/ }
                        <div className="main_popup delete_user_popup">
                            <div className="main_popup_wrapper">
                                <div className="main_popup_bg_shadow"></div>
                                <div className="main_popup__inner">
                                    <div className="popup_wrap"> <span className="close_icon" data-toggle="tooltip" title="" data-original-title="Close" onClick={ (e) => this.close(e, "delete") }></span>
                                        <div className="popup_header">
                                            <div className="sub_title"> Delete</div>
                                        </div>
                                        <div className="popup_body">
                                            <p>Are you sure you want to delete the SSH key <b> { this.state.deletekeyname }</b> ?</p>
                                        </div>
                                        <div className="popup_footer">
                                            <div className="popup_footer__btns">
                                                <button id="deleteSshKey" className="btn btn_confirm" onClick={ this.deleteKey }>Delete</button>
                                                <button className="btn btn_cancel" onClick={ (e) => this.close(e, "delete") }>Cancel</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* End of delete SSH key */ }
                        {/* Main SSHKey View Details Slider */ }
                        <div className="main_slider sshKey_viewDetail_slider">
                            <div className="slider_bg_shadow"></div>
                            <div className="slider_wrapper">
                                <div className="main_slider_container">
                                    <div className="close_icon" onClick={ (e) => this.close(e, "viewssh") }></div>
                                    <div className="sshViewDetail_slide_wrap">
                                        <div className="head_block">
                                            <h2><span className="icon_img"> <span className="svg_wrap"><svg x="0px" y="0px" viewBox="0 0 23 23" enableBackground="new 0 0 23 23" xmlSpace="preserve">
                                                <path fillRule="evenodd" clipRule="evenodd" fill="#606060" d="M11.5,18.5c-8,0-10-7-10-7s2.1-7,10-7c8.7,0,10,7,10,7  S19.3,18.5,11.5,18.5z M11.5,6.5c-6.6,0-8,5-8,5s1.2,5,8,5s8-5,8-5S18.1,6.5,11.5,6.5z M11.5,15.5c-2.2,0-4-1.8-4-4s1.8-4,4-4  s4,1.8,4,4S13.7,15.5,11.5,15.5z M11.5,9.5c-1.1,0-2,0.9-2,2s0.9,2,2,2s2-0.9,2-2S12.6,9.5,11.5,9.5z" />
                                                <g display="none">
                                                    <path display="inline" fill="#606060" d="M17.8,6.2l-1.5,1.5c2.5,1.5,3.2,3.8,3.2,3.8s-1.2,5-8,5C10.1,16.5,9,16.3,8,16l-1.5,1.5   c1.3,0.6,2.9,1.1,4.9,1.1c7.8,0,10-7,10-7S20.9,8.3,17.8,6.2z" />
                                                    <path display="inline" fill="#606060" d="M5.3,16.7l1.3-1.3c-2.6-1.5-3.1-3.8-3.1-3.8s1.4-5,8-5c1.4,0,2.5,0.2,3.4,0.6l1.6-1.6   c-1.3-0.6-2.9-1-5-1c-7.9,0-10,7-10,7S2.4,14.6,5.3,16.7z" />
                                                    <path display="inline" fill="#606060" d="M13.5,11.5c0,1.1-0.9,2-2,2c-0.3,0-0.6-0.1-0.8-0.2l-1.5,1.5c0.6,0.4,1.4,0.7,2.3,0.7   c2.2,0,4-1.8,4-4c0-0.8-0.3-1.6-0.7-2.3l-1.5,1.5C13.4,10.9,13.5,11.2,13.5,11.5z" />
                                                    <path display="inline" fill="#606060" d="M7.5,11.5c0,0.8,0.3,1.6,0.7,2.3l1.5-1.5c-0.1-0.2-0.2-0.5-0.2-0.8c0-1.1,0.9-2,2-2   c0.3,0,0.6,0.1,0.8,0.2l1.5-1.5c-0.6-0.4-1.4-0.7-2.3-0.7C9.3,7.5,7.5,9.3,7.5,11.5z" />

                                                    <rect x="11.8" y="2.2" transform="matrix(0.7071 0.7071 -0.7071 0.7071 12.5 -5.1777)" display="inline" fillRule="evenodd" clipRule="evenodd" fill="#606060" width="1.4" height="20.7" />
                                                </g>
                                            </svg></span> </span>SSH Key Details</h2>
                                        </div>
                                        <div className="sshViewDetailRhs_content_wrap">
                                            <p className="info_txt" style={ { display: "none" } }>View information about the SSH Keys for the instance. </p>
                                            <div className="common_txtBox_row">
                                                <label>Key Name</label>
                                                <input type="text" value={ this.state.viewsshname } className="txt_box disabled" readOnly></input>
                                            </div>

                                            <div className="common_txtBox_row">
                                                <label>Email</label>
                                                <input type="text" value={ this.state.viewsshuser } className="txt_box disabled" readOnly></input>
                                            </div>

                                            <div className="common_txtBox_row">
                                                <label>Created On</label>
                                                <input type="text" value={ this.state.viewcreateddate } className="txt_box disabled" readOnly></input>
                                            </div>
                                            <div class="common_txtBox_row">
                                                <label>SSH Public Key</label>
                                                <textarea name="sshpubkey" id="viewpubkey" value={ this.state.viewpubkey } class="txt_box" readOnly></textarea>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        { /* Main SSHKey View Details Slider Ends*/ }
                    </div>
                </main>
                <CommonMessage message={ this.state.message } msgType={ this.state.msgType } isUserSubscribed={ this.state.isUserSubscribed } handler={ () => this.setState({ message: '' }) } />
            </div>
        );
    }
}
function asyncCall() {
    return new Promise((resolve) => setTimeout(() => resolve(), 1000));
}
export default SshKey;